module.exports = __webpack_public_path__ + "img/self-assessment.249c91bc.png";